//const locationStore = new LocationStore({ configuration: configuration, tryUpdateCurrentHospital: hospitalAppStore.tryUpdateCurrentHospital });

import { useApp } from "@common/hooks/useApp";
import { LocationStoreContextWrapper } from "@hospital/contexts";
import { useHospitalApp } from "@hospital/hooks";
import { LocationStore } from "@hospital/views/admin/locations";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";

/**
 * Create an useHospitalApp while optionally setting it in the useHospitalApp Context Wrapper.  You might want to set it in context so child components can access the same instance of the useHospitalApp
 * @param options
 * @returns
 */
export const useCreateLocationStore = (options?: { shouldSetContext?: boolean }) => {
    const [shouldSetContext, setShouldSetContext] = useState<boolean>(Boolean(options?.shouldSetContext));

    const { configuration } = useApp();
    const hospitalAppStore = useHospitalApp();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (options)
            setShouldSetContext(Boolean(options.shouldSetContext));
    }, [options])

    const [locationStore] = useMemo(() => {
        const store = new LocationStore({ configuration, tryUpdateCurrentHospital: hospitalAppStore.tryUpdateCurrentHospital, queryClient, queryStaleTime: configuration.shortClientSideCacheTimeToLive });
        if (shouldSetContext)
            LocationStoreContextWrapper.set(store);
        return [store];
    }, [configuration, hospitalAppStore, shouldSetContext, queryClient]);
    return locationStore;
}
